import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import styles, { inputTheme } from './styles'

const RadioInput = ({ id, ...props }) => (
  <>
    <input
      id={id}
      type="radio"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={cx(styles.input, inputTheme(props.theme))}
    />

    <label className={cx(styles.label, props.className)} htmlFor={id}>
      {props.label}
    </label>
  </>
)

RadioInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  checked: PropTypes.bool,
  autoFocus: PropTypes.bool,
  theme: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
}

export default RadioInput
